<template>
  <div>
    <div v-html="temp.resultStyle"></div>
    <div class="start" v-if="!GameStatic.start">
      <div class="card content animated fadeInDown">
        <h5 class="card-header">歡迎挑戰 Flexbox 海盜</h5>
        <div class="card-body">
          <!-- <h2 class="h2 text-center text-success" v-if="data.length">
            目前已有 {{ data[0].total }} 位挑戰者成功過關
          </h2> -->
          <h5 class="card-title">故事背景</h5>
          <p class="card-text">
            有一天 FLEX 海盜集團襲擊了國王的領土，還偷走了皇冠。
            <br>國王決定派出六角戰艦，欲將 FLEX 海盜集團殲滅並取出皇冠。
            <br>FLEX 海盜集團的活動範圍被分為 20 層，想要拿到皇冠需要達到 FLEX 最深層才行。
          </p>
          <h5 class="card-title mt-4">遊戲辦法</h5>
          <p class="card-text">
            請將<b>座標圖上的準心瞄準到對應的海盜船上</b>，瞄準完成後按下紅色按鈕發射飛彈，一層一層將 FLEX 海盜集團攻破!
          </p>
        </div>
        <div class="card-footer text-muted text-right">
          <a href="#" class="btn btn-success" @click.prevent="startGame">馬上開始</a>
        </div>
      </div>
    </div>
    <div class="container-fluid">
      <div class="row">
        <div class="col-4 col-lg-4 left-con">
          <h2 class="mt-5 h2">Flex Pirate 挑戰</h2>
          <hr>
          <div class="question mb-3 card">
            <div class="card-body">
            <a :href="game[levelVal].study" target="_blank" class="w3hex-link">
              <i class="fas fa-book"></i> 教學
            </a>
            <p class="mb-1">Level  <b>{{levelVal+1}}</b> /20</p>
            {{ game[levelVal].topic }}
            <p class="notice" v-html="game[levelVal].notice"></p>
            <Notice :displayData="game[levelVal].displayData"></Notice>
            </div>
          </div>
          <div class="code-arry">
            <div class="codes" v-for="(item, index) in game[levelVal].prompt" :key="index">
              <b>{{ item }}</b> {
              <textarea :id="'code'+index" rows="6" @keydown.tab.prevent
              v-model="temp.writeStyle[index]"></textarea>
              }
            </div>
            <p class="hit" v-if="GameStatic.nextBtn !== '發射'">
              <span>{{ GameStatic.nextBtn }}</span>
            </p>
          </div>
          <div class="wrong mt-3 card border-danger" v-if="temp.wrongCode">
            <div class="card-body">
              {{ temp.wrongCode }}
            </div>
          </div>
          <button class="btn btn-danger mt-5"
          @click="checkAnswer" v-if="GameStatic.nextBtn == '發射'">
            {{ GameStatic.nextBtn }}
          </button>
          <button class="btn btn-warning mt-5"
          @click="nextPage" v-if="GameStatic.nextBtn !== '發射'">
            下一關
          </button>
        </div>
        <div class="col-8 col-lg-8 playground">
          <nav class="playNav">
            <p class="level">Level.{{ levelVal+1 }}</p>
          </nav>
          <div class="flexbox" :id="'p'+levelVal">
            <h3 class="main" v-if="temp.direction === -1">主軸線</h3>
            <h3 class="vice" v-if="temp.direction === -1">交錯軸</h3>
            <h3 class="vice column" v-if="temp.direction !== -1">主軸線</h3>
            <h3 class="main column" v-if="temp.direction !== -1">交錯軸</h3>
            <div v-html="game[levelVal].html"></div>
            <!-- grids -->
            <div class="flex-container">
              <div class="grid-con">
                <div :class="{main:true, column:temp.direction !== -1}"></div>
                <div :class="{vice:true, column:temp.direction !== -1}"></div>
                <div class="grid" v-for="item in 36" :key="item"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from 'jquery';
import Notice from '../../components/Notice.vue';
import question from '../../assets/js/question';

export default {
  name: 'Simple',
  props: ['user'],
  data() {
    return {
      data: [],
      levelVal: 0,
      temp: {
        writeStyle: [],
        resultStyle: '',
        wrongCode: '',
        ansRight: true,
        direction: -1,
      },
      GameStatic: {
        start: false,
        nextBtn: '發射',
        end: false,
        second: 0,
      },
      game: question,
    };
  },
  watch: {
    'temp.writeStyle': {
      handler: function cssStyle(val) {
        const vm = this;
        const str = vm.resultCSS(val);
        vm.temp.resultStyle = `<style>${str}</style>`;
        vm.temp.direction = str.replace(/\s+/g, '').indexOf('flex-direction:column');
      },
      deep: true,
    },
  },
  components: {
    Notice,
  },
  methods: {
    getData() {
      // const api = 'https://flexbox-api-test.herokuapp.com/participantcount';
      // const vm = this;
      // this.$http.get(api).then((response) => {
      //   vm.data = response.data;
      // });
    },
    trimSemiColon(text) {
      return text.slice(-1) === ';' ? text.slice(0, this.length - 1) : text;
    },
    JsonCSS(text) {
      const vm = this;
      if (typeof text !== 'string') {
        console.error('Need a CSS string but given ', typeof text, text);
        return 'Not a valid CSS..!';
      }
      const output = {};
      let lastKey;
      let term;
      let style;
      const regExp = /\r\n|\r|\n|\u2028|\u2029/g;
      try {
        text.split('{').forEach((item) => {
          term = item.trim();
          if (term) {
            if (term.indexOf('}') === -1) {
              // it's a selector
              output[term] = {};
              lastKey = term;
            } else {
              // contains styles and next selector
              term.substring(0, term.indexOf('}')).split(';').forEach((keyValue) => {
                style = keyValue.split(':');
                if (style && style.length === 2) {
                  output[lastKey][style[0].trim().replace(regExp, '')] = vm.trimSemiColon(style[1].trim().replace(regExp, ''));
                }
              });
              try {
                // may be End of Styles
                lastKey = term.split('}')[1].trim();
                if (lastKey) {
                  // for new selector
                  output[lastKey] = {};
                }
              } catch (e) {
                // no more selectors for our life
              }
            }
          }
        });
      } catch (e) {
        return 'Not a valid CSS..!';
      }
      return output;
    },
    resultCSS(val) {
      const vm = this;
      let str = '';
      for (let i = 0; i < val.length; i += 1) {
        str += `
          ${vm.game[vm.levelVal].prompt[i]}{
            ${val[i]}
          }
        `;
      }
      return str;
    },
    checkAnswer() {
      const vm = this;
      // const ans = vm.game[vm.levelVal].ans;
      const { ans } = vm.game[vm.levelVal];
      const objKeyArry = Object.keys(ans);
      vm.temp.wrongCode = '';
      vm.temp.ansRight = true;
      let pass = false;
      // 填寫答案物件 {.aims...}
      const UserAnsObj = vm.JsonCSS(vm.resultCSS(vm.temp.writeStyle));
      for (let i = 0; i < objKeyArry.length; i += 1) {
        // .aims
        const objclass = objKeyArry[i];
        // {color:red}
        const userObj = UserAnsObj[objclass];
        const userAnsCssArry = Object.keys(userObj);
        const checkKey = vm.game[vm.levelVal].ans[objclass];
        for (let ii = 0; ii < userAnsCssArry.length; ii += 1) {
          // color
          const userKey = userAnsCssArry[ii];
          // red
          const userVal = userObj[userKey];
          if (ans[objclass][userKey]) {
            const arryAns = ans[objclass][userKey].find(item => item === userVal);
            if (arryAns) {
              // 對
            } else {
              vm.temp.wrongCode = `${userKey} 的值錯誤`;
              vm.temp.ansRight = false;
            }
          } else {
            vm.temp.wrongCode = `不需要用到 ${userKey}`;
            vm.temp.ansRight = false;
            return false;
          }
        }
        pass = Object.keys(checkKey).sort().toString() === userAnsCssArry.sort().toString();
        // console.log(Object.keys(checkKey),userAnsCssArry,vm.temp.ansRight);
      }
      // 如果都正確


      if ((vm.levelVal === 7) && pass && vm.temp.ansRight) {
        vm.GameStatic.nextBtn = '移動成功';
      } else if (pass && vm.temp.ansRight) {
        vm.GameStatic.nextBtn = '闖關成功';
        $('.ships .item').addClass('shake-opacity').addClass('shake-constant').addClass('shake-constant--hover')
          .fadeOut(1500);
      } else if (vm.temp.wrongCode && pass) {
        vm.temp.ansRight = true;
        vm.temp.wrongCode = '沒有打中';
      }
      return false;
    },
    nextPage() {
      const vm = this;
      $('.ships .item').removeClass('shake-opacity').removeClass('shake-constant').removeClass('shake-constant--hover')
        .fadeIn(0);
      if (vm.levelVal === 19) {
        vm.endGame();
      } else if (vm.levelVal === 21
        || vm.levelVal === 22) {
        vm.levelVal += 1;
        vm.temp.writeStyle = [];
        vm.temp.wrongCode = '';
        vm.GameStatic.nextBtn = '發射';
      } else {
        vm.levelVal += 1;
        vm.temp.writeStyle = [];
        vm.temp.writeStyle[0] = 'display: flex;';
        vm.temp.wrongCode = '';
        vm.GameStatic.nextBtn = '發射';
      }
    },
    startGame() {
      const vm = this;
      const startTime = new Date();
      vm.GameStatic.start = true;
      localStorage.setItem('startTime', String(startTime));
      localStorage.setItem('endTime', '');
    },
    endGame() {
      const vm = this;
      const endTime = new Date();
      vm.GameStatic.end = true;
      localStorage.setItem('endTime', String(endTime));
      this.$router.push('simple_end');
    },
  },
  created() {
    this.getData();
    window.onbeforeunload = (e) => {
      e.returnValue = '離開後不會保存此次對戰紀錄';
    };
  },
};
</script>

<style lang="scss" scoped>
  $dark-1: #00251A;
  $dark-2: #004D40;
  $dark-3: #2BBD7E;
  $dark-4: #69F0AE;
  .left-con {
    background-color: $dark-3;
    padding-bottom: 50px;
    h2 {
      text-align: right;
      color: $dark-2;
      font-weight: bold;
    }
    .question {
      background-color: #eeeeee;
      line-height: 1.5;
      position: relative;
      .w3hex-link{
        position: absolute;
        right: 10px;
        top: 10px;
        font-size: 14px;
        color: rgba(#000, 0.5);
        font-weight: bold;
        transition: all 0.2s ease-in-out;
        &:hover{
          text-decoration: none;
          color: rgba(#000, 0.8);
        }
      }
      p{
        font-weight: bold;
        font-size: 16px;
        color: $dark-3;
        b{
          font-weight: bolder;
          font-size: 20px;
        }
      }
      .notice {
        color: #999;
        font-size: 12px;
        b{
          color: $dark-4;
        }
      }
    }
    .code-arry{
      position: relative;
      .hit {
        position: absolute;
        width: 100%;
        height: 100%;
        color: red;
        background-color: rgba(0,0,0,0.5);
        top: 0;
        left: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        font-weight: bold;
        font-size: 60px;
        font-family: "Microsoft JhengHei UI",
                      PMingLiU,MingLiu,"Segoe UI","Helvetica",Garuda,Arial,sans-serif;
        z-index: 1;
        span{
          transform: rotate(-7deg);
        }
      }
    }
    .codes {
      font-family: monospace;
      font-size: 16px;
      padding: 15px;
      background-color: #333;
      color: #fff;
      position: relative;
      b{
        color: #feca56;
      }
      textarea {
        display: block;
        border: none;
        background-color: transparent;
        color: #fff;
        resize: none;
        overflow: hidden;
        padding: 3px 0px 3px 25px;
        width: 100%;
        &:focus {
          outline: none;
        }
      }
    }
  }
  .start, .end {
    position: fixed;
    z-index: 100;
    background-color: rgba(20,20,20,0.9);
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    .content {
      width: 650px;
      max-width: 100%;
      background-color: #fff;
      .card-text{
        line-height: 1.5;
      }
      .card-title{
        font-weight: bold;
        font-size: 18px;
      }
    }
  }
</style>
